import React from "react";
import { Navbar, NavbarBrand, NavbarNav, NavItem } from "mdbreact";
class NavbarPage extends React.Component {
  render() {
  var NavbarStyle = {
    backgroundColor: '#3F729B',
  }
    return (
      <Navbar style={NavbarStyle} dark expand="md">
          <NavbarBrand>
            <strong className="white-text"> Search for Images...</strong>
          </NavbarBrand>
          <NavbarNav right>
            <NavItem>
              <a href="/" className="white-text" >Home</a>
            </NavItem>
          </NavbarNav>
      </Navbar>
    );
  }
}

export default NavbarPage;